import { render, staticRenderFns } from "./AdminDashboardPage.vue?vue&type=template&id=b9668264&scoped=true"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=js"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboardPage.vue?vue&type=style&index=0&id=b9668264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9668264",
  null
  
)

export default component.exports